import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blog/BlogPageClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/BlogListPageSkeleton.js");
